import React, { useState } from 'react';
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Container,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { environment } from '../../../environments/environment';

const faqData = [
  {
    id: 1,
    question: 'What services does your software development company offer?',
    answer:
      'We offer a comprehensive range of software development services including web and mobile application development, custom software solutions, API integrations, and cloud services. Our team follows step-by-step instructions to add your contact information, social media links, and any multimedia content you want to include. Once set up, your digital card is ready to be shared instantly.',
  },
  {
    id: 2,
    question: 'What services does your software development company offer?',
    answer:
      'Our development process includes thorough planning, agile development methodology, quality assurance testing, and ongoing support and maintenance.',
  },
  {
    id: 3,
    question: 'What services does your software development company offer?',
    answer:
      'We specialize in modern technologies including React, Node.js, Python, cloud platforms like AWS and Azure, and mobile development for iOS and Android.',
  },
  {
    id: 4,
    question: 'What services does your software development company offer?',
    answer:
      'Project timelines vary based on complexity, but typically range from 2-6 months for most applications. We provide detailed timelines during our initial consultation.',
  },
  {
    id: 5,
    question: 'What services does your software development company offer?',
    answer:
      'Yes, we offer comprehensive support and maintenance packages to ensure your software remains updated, secure, and performing optimally.',
  },
];

export default function FAQAccordion() {
  const [expanded, setExpanded] = useState(1); 

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          paddingX: { xs: '16px', sm: '24px', md: '42px' },
        }}
      >
        {faqData.map((faq) => (
          <Accordion
            key={faq.id}
            expanded={expanded === faq.id}
            onChange={handleChange(faq.id)}
            sx={{
              mb: 2,
              borderRadius: '16px !important',
              boxShadow: '0px 4px 20px 0px #0000000D !important',
              '&:before': {
                display: 'none',
              },
              '&.Mui-expanded': {
                margin: '0 0 16px 0',
                border: `1px solid ${environment.mainColor}`,
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded === faq.id ? (
                  <Box
                    sx={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: environment.mainColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <RemoveIcon sx={{ color: 'white', fontSize: 20 }} />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: environment.mainColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <AddIcon sx={{ color: 'white', fontSize: 20 }} />
                  </Box>
                )
              }
              sx={{
                flexDirection: 'row',
                '& .MuiAccordionSummary-expandIconWrapper': {
                  marginLeft: 2,
                  marginRight: 0,
                },
                '& .MuiAccordionSummary-content': {
                  margin: '16px 0',
                },
                minHeight: 64,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: expanded === faq.id ? 700 : 500,
                  fontSize: '16px',
                  fontFamily: 'poppins, sans-serif',
                  color: expanded === faq.id ? '#101828' : '#172B4D',
                  lineHeight: 1.4,
                }}
              >
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                pt: 0,
                pb: 3,
                px: 3,

                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#3E404E',
                  lineHeight: '160%',
                  fontSize: '14px',
                  fontFamily: 'poppins, sans-serif',
                  fontWeight: 400,
                  letterSpacing: '0%',
                }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Grid>
  );
}
